import React from 'react';

import { Box } from '@mui/material';

interface ITruncateBox {
  children?: React.ReactNode;
}

export const TruncateBox: React.FC<ITruncateBox> = (props) => {
  const { children } = props;

  return (
    <Box
      sx={{
        pr: '70px',
        '> *': {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },
      }}
    >
      {children}
    </Box>
  );
};
